import { Chip, Typography } from '@mui/material'
import { useMemo } from 'react'

import { MembershipSubscriptionPlanStatus } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

export type MembershipCategoryProps = {
  status: string
}

export const MembershipCategory: Organism<MembershipCategoryProps> = ({
  status,
}) => {
  const { t } = useTranslation('consoleMembershipDetail')

  const { label, bgcolor } = useMemo(() => {
    if (status === MembershipSubscriptionPlanStatus.Active) {
      return { label: t('published'), bgcolor: 'primary.main' }
    }
    return { label: t('unpublish'), bgcolor: 'grey.300' }
  }, [t, status])

  return (
    <Chip
      size="small"
      sx={{
        height: 16,
        borderRadius: '2px',
        bgcolor,
        py: 1,
        px: '2px',
        '.MuiChip-label': { px: 0 },
      }}
      label={
        <Typography color="white" variant="overline" display="block">
          {label}
        </Typography>
      }
    />
  )
}
